<template>
  <div v-if="report">
    <div
      v-for="field in fieldOrder"
      :key="field"
      class="mb-3 pb-3 border-bottom"
    >
      <p class="text-uppercase text-muted small fw-semibold mb-1">
        {{ fieldLabel(field) }}
      </p>
      <div>
        <template v-if="hasValue(field)">
          <ul v-if="Array.isArray(valueFor(field))" class="mb-0 ps-3">
            <li v-for="(item, index) in valueFor(field)" :key="index">
              {{ item }}
            </li>
          </ul>
          <p v-else class="mb-0">
            {{ valueFor(field) }}
          </p>
        </template>
        <p v-else class="mb-0 text-muted">No entry yet</p>
      </div>
    </div>
  </div>
  <div v-else class="text-muted text-center py-5">No submission selected.</div>
</template>

<script>
import { ISLAND_DISPLAY_CONFIG } from "@/helpers/displayConfig.js";
export default {
  name: "SubmissionView",
  props: {
    report: {
      type: Object,
      default: null
    },
    fieldOrder: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    fieldLabel(field) {
      return (
        ISLAND_DISPLAY_CONFIG.find((config) => config.field === field)?.label ||
        field
      );
    },
    valueFor(field) {
      if (!this.report || !this.report.reportDetails) return "";
      return this.report.reportDetails[field] || "";
    },
    hasValue(field) {
      const value = this.valueFor(field);
      if (Array.isArray(value)) {
        return value.some((entry) => entry && entry.toString().trim().length);
      }
      return value && value.toString().trim().length;
    }
  }
};
</script>
